const Form076PICSSC = {
    picsTitle: "个人资料收集声明",
    subtitleList: [
        { text: "收集个人资料的目的" },
        { text: "可获转移资料者" },
        { text: "查阅个人资料" },
    ],
    symbolStep: [
        { step: "(a)" },
        { step: "(b)" },
        { step: "(c)" },
        { step: "(d)" },
        { step: "(e)" },
        { step: "(f)" },
        { step: "(g)" },
    ],
    firstStep: [
        {
            text: "你在本表格提供的个人资料，会供教育局用于以下一项或多项用途：",
        },
        {
            text: "你必须按本表格的要求及于本局处理本表格的过程中提供个人资料。假如你没有提供该等个人资料，本局可能无法办理或继续处理有关申请。 ",
        },
        {
            text: "你提供的个人资料会供教育局人员取阅。除此之外，本局亦可能会向下列各方或在下述情况转移或披露该等个人资料：",
        },
        {
            text: "你有权要求查阅及更正教育局所持有关于你的个人资料。如需查阅或更正个人资料，请以书面向助理教育主任(学位安排及支援)31提出(地址：香港湾仔皇后大道东213号胡忠大厦14楼1424室或电邮：aeops31@edb.gov.hk)。",
        },
    ],
    secondStep: [
        { text: "处理、核实、审核资格及查证就学位安排的申请；" },
        {
            text: "就上文(a)项所述申请的处理、核实、审核资格及查证，将个人资料与政府相关政策局／部门资料库进行核对； ",
        },
        {
            text: "将个人资料与教育局资料库进行核对，以核实／更新教育局的记录；以及",
        },
        { text: "编制统计资料、研究及政府刊物。" },
    ],
    thirdStep: [
        { text: "政府其他政策局及部门，以用于上文第1段所述的用途；" },
        { text: "与本表格相关的学校，以用于上文第1段所述的用途；" },
        { text: "你曾就披露个人资料给予订明同意；以及" },
        { text: "根据适用于香港的法例或法庭命令授权或规定披露个人资料。" },
    ],
};

export default Form076PICSSC;
